var _defs, _g, _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaijiezhen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0;}.cls-2,.cls-4,.cls-5{fill:red;}.cls-2{opacity:0.13;}.cls-3{fill:#ff6700;opacity:0.1;}.cls-4{opacity:0.09;}.cls-5{opacity:0.03;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02_\u5F85\u63A5\u8BCA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.22,
    y: 4,
    width: 56,
    height: 56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 32.28,
    cy: 31.91,
    r: 28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.29,
    y: 7.91,
    width: 56,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8.29,
    y: 3.91,
    width: 48,
    height: 56
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.21,8.49A21.53,21.53,0,1,1,8.68,30,21.55,21.55,0,0,1,30.21,8.49m0-4.4A25.93,25.93,0,1,0,56.13,30,25.92,25.92,0,0,0,30.21,4.09Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.17,
    y: 43.92,
    width: 4,
    height: 18.27,
    rx: 2,
    transform: "translate(-21.94 53.14) rotate(-45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.09,22.11l.13.27,4.22,10.51,2.75-4.4a1.87,1.87,0,0,1,1.34-.88l.28,0h5.48a1.91,1.91,0,0,1,.26,3.8l-.26,0H37.86L33.69,38.1a1.9,1.9,0,0,1-2.63.61,2,2,0,0,1-.64-.65l-.12-.26-3.82-9.51-.88,2.29a1.89,1.89,0,0,1-1.52,1.2l-.26,0H18.11a1.91,1.91,0,0,1-.26-3.8l.26,0h4.4l2.16-5.58A1.91,1.91,0,0,1,28.09,22.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaijiezhen);
export default __webpack_public_path__ + "static/media/daijiezhen.5107365d.svg";
export { ForwardRef as ReactComponent };